export default __webpack_public_path__ + "static/media/nfts.76ead0dc.png";